import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IMenuItem } from '../menu-base/menu-base.component';

@Component({
  selector: 'app-menu-section',
  templateUrl: './menu-section.component.html',
  styleUrls: ['./menu-section.component.scss']
})
export class MenuSectionComponent implements OnInit {
    @Input() item: IMenuItem;
    @Output() submenuOpened = new EventEmitter<IMenuItem>();

    
    constructor() { }

    ngOnInit(): void {
    }

    toggleSubMenu(){
        if(this.item.submenuShow){
            this.item.submenuShow = false;
        }else{
            this.item.submenuShow = true;
            this.submenuOpened.emit(this.item);
        }

    }
}
